import Head from 'next/head'
import PageHeaderBanner from '@bww/beke-ui/PageHeader'
import YourDreamCTA from '@bww/beke-ui/YourDreamCTA'
import { sanityClient } from '@bww/beke-lib/sanity-client'
import Testimonial from '@bww/beke-ui/Testimonials'
import { createExcept } from '@bww/beke-lib/pt-excerpt'

export default function TestimonialsPage({ testimonials }) {
  return (
    <>
      <Head>
        <title>What our clients say about their bathrooms</title>
        <meta
          name="description"
          content="Client testimonials for Bathroom Elegance"
        />
      </Head>
      <PageHeaderBanner title="Client Testimonials" noMargin />
      <div className="pageContainer">
        {testimonials.map(
          ({ clientName, date, pullQuote, testimonial, excerpt, _id }) => (
            <Testimonial
              name={clientName}
              pullQuote={pullQuote}
              date={date}
              excerpt={excerpt.blocks}
              isCapped={excerpt.isCapped}
              body={testimonial}
              key={_id}
            />
          ),
        )}
      </div>
      <YourDreamCTA />
    </>
  )
}

export async function getStaticProps() {
  const testimonials = await sanityClient.fetch(
    `*[_type == "testimonial" && company == "be"] | order(date desc, _createdAt desc)[0..29]`,
  )

  const testimonialsWithExcerpt = testimonials.map((t) => {
    const excerpt = createExcept(t.testimonial)
    return { ...t, excerpt }
  })

  return {
    props: {
      testimonials: testimonialsWithExcerpt,
    },
  }
}
